<template>
    <popup :opened="dataToShow > -1" @close="close">

        <!-- BEGIN Content modal add referent -->
        <div v-if="dataToShow == 1">
            <div class="my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32">
                <h3 class="mb-10">Confirmer l'annulation du renouvelement automatique</h3>

                <h6 class="w-full text-center text-indigo-600 mb-5">
                    Votre abonnement prendra fin le {{endDate}}.
                </h6>
                <h6 class="w-full text-center text-indigo-600 mb-10">
                    Êtes-vous sûr de vouloir désactiver le renouvelement automatique de votre abonnement ?
                </h6>

                <div class="flex justify-center space-x-5">
                    <action-button
                        border-color="border-pink-600"
                        text-color="text-pink-600"
                        bg-color="bg-pink-100"
                        bg-color-square="bg-pink-100"
                        icon-color="text-white"
                        libelle="Annuler"
                        :uppercase="true"
                        @clickAction="close(-1);"
                    />
                    <action-button
                        border-color="border-transparent"
                        text-color="text-white"
                        bg-color="bg-pink-600"
                        bg-color-square="bg-pink-600"
                        icon-color="text-white"
                        libelle="Désactiver"
                        :uppercase="true"
                        type-shadow="shadow-pink"
                        @clickAction="confirmCancelSubscription()"
                    />
                </div>
            </div>
        </div>
        <!-- END Content modal add referent -->

        <!-- BEGIN Sucess message to add a referent -->
        <div v-else-if="dataToShow == 2">
            <div class="m-5 lg:m-15 2xl:m-20">
                <h3 class="w-full text-pink-600 mb-10">Le renouvelement automatique a été annulé !</h3>

                <div class="mb-10">
                    <p class="text-indigo-600 text-lg text-center">Votre abonnement Neopass s'arrêtera le {{endDate}}</p>
                    <p class="text-indigo-600 text-lg text-center">Vous pouvez continuer à utiliser l'application Neopass jusqu'à cette date.</p>
                </div>

                <illustration name="basket" class="w-full" />
            </div>
        </div>
        <!-- END Sucess message to add a referent -->

        <!-- BEGIN error message to add a referent -->
        <div v-else-if="dataToShow == 100">
            <div class="m-5 lg:m-15 2xl:m-20">
                <h3 class="w-full text-pink-600 mb-10">Erreur lors de l'annulation du renouvelement automatique !</h3>

                <div class="mb-10">
                    <p class="text-indigo-600 text-lg text-center">Le renouvelement automatique n'a pas pu être annulé.</p>
                </div>

                <illustration name="notAllowed" class="w-full" />
            </div>
        </div>
        <!-- END error message to add a referent -->
    </popup>
</template>

<script>
import Popup from './../../../components/Popup';
import Icon from './../../../components/Icon';
import Illustration from './../../../components/Illustration';
import ActionButton from './../../../components/ActionButton';

export default {
  name:'CancelSubscriptionPopup',

  props:{
    dataToShow: Number,
    endDate: Date,
  },

  data() {
    return {

    };
  },

  components:{
    Popup,
    Icon,
    Illustration,
    ActionButton,
  },

  computed:{
    //
  },

  methods:{
    close(val){
      this.$emit('close');
    },

    confirmCancelSubscription(){
      this.$emit('cancelSubscription');
    }
  }
};
</script>
